module.exports = __webpack_public_path__ + "img/yfi.bd85a86b.svg";